export const baseurImage = 'https://holistic.gpulse.cloud/Backend/'
export const baseurl = 'https://holistic.gpulse.cloud/Backend/api/'
